// ============================================
// DOSSIERS « SPAM POSSIBLE »
// ============================================
// Un e-mail que Microsoft a jugé indésirable (dossier « Courrier
// indésirable », ou SCL 5 à 8) sans être un spam évident devient un dossier à
// qualifier marqué `spamPossible` (backend : inbound-mail/classify.ts). Tant
// que la marque est posée, rien ne part vers l'expéditeur. Le personnel
// tranche depuis la fiche : « Pas un spam » ou « Spam » (POST
// /admin/tickets/:id/pas-spam et /spam).

import { AdminApi } from '../../services/api';

/** Libellé du badge, dans la liste comme sur la fiche. */
export const LIBELLE_SPAM_POSSIBLE = 'Spam possible';

/** Couleur d'alerte existante (priorité urgente, statut escaladé). */
export const CLASSE_SPAM_POSSIBLE = 'bg-[#FBE9E7] text-[#8A1C16] border border-[#F2C4BF]';

/** Le dossier porte-t-il la marque ? Lu sans dépendre du type `Ticket`. */
export function estSpamPossible(dossier: unknown): boolean {
  return typeof dossier === 'object' && dossier !== null
    && (dossier as { spamPossible?: unknown }).spamPossible === true;
}

/** Le bandeau de décision s'affiche sur un dossier marqué qui n'est pas clos. */
export function decisionSpamAttendue(dossier: unknown): boolean {
  return estSpamPossible(dossier) && (dossier as { status?: unknown }).status !== 'CLOSED';
}

export type DecisionSpam = 'pas-spam' | 'spam';

/** Phrase de confirmation, après une décision réussie. */
export function avisDecisionSpam(decision: DecisionSpam, resultat: { contactEmail?: string | null; deplacement?: string }): string {
  if (decision === 'spam') return 'Dossier clos comme spam. Aucune notification n\'a été envoyée.';
  const morceaux = ['Ce n\'est pas un spam : le dossier suit le circuit normal.'];
  if (resultat.contactEmail) morceaux.push(`Adresse de contact : ${resultat.contactEmail}.`);
  else morceaux.push('Expéditeur non authentifié : vérifiez son adresse avant de lui répondre.');
  if (resultat.deplacement === 'echec') morceaux.push('Le message n\'a pas pu être remis en boîte de réception dans Outlook.');
  return morceaux.join(' ');
}

/** Envoie la décision au serveur. Lève l'erreur de l'API (409 dossier déjà tranché…). */
export async function trancherSpam(ticketId: string, decision: DecisionSpam) {
  return decision === 'spam' ? AdminApi.marquerSpam(ticketId) : AdminApi.marquerPasSpam(ticketId);
}
